export default class Sbl {
  constructor(lib, parent, pos) {
    this.lib = lib;
    this.parent = parent;
    this.view = null;
    this.row = Math.floor(pos / 5);
    this.col = pos % 5;
  }

  setId(id) {
    this.id = id;
    this.parent.removeChild(this.view);

    // console.log('★ Sbl.setId', id);

    this.view = new this.lib[`Symbol${id}`]();
    this.view.set({
      x: (this.col * 202) + 318,
      y: (this.row * 208) + 180,
      regX: this.view.getBounds().width / 2,
      regY: this.view.getBounds().height / 2,
      alpha: 0,
      scaleX: 0.3,
      scaleY: 0.3,
    });
    this.parent.addChild(this.view);
  }

  play(id) {
    this.setId(id);
    return new Promise(resolve =>
      createjs.Tween.get(this.view)
        .to({ scaleX: 1, scaleY: 1, alpha: 1 }, 170)
        .call(resolve)
        .to({ scaleX: 1.3, scaleY: 1.3 }, 150)
        .to({ scaleX: 1, scaleY: 1 }, 150));
  }

  playWin() {
    this.view.set({ scaleX: 1, scaleY: 1 });
    createjs.Tween.get(this.view, { loop: true, override: true })
      .to({ scaleX: 1, scaleY: 1 }, 250)
      .to({ scaleX: 1.3, scaleY: 1.3 }, 200)
      .to({ scaleX: 1, scaleY: 1 }, 200)
      .to({ scaleX: 1.3, scaleY: 1.3 }, 200)
      .to({ scaleX: 0.8, scaleY: 0.8 }, 250);
  }

  stop() {
    if (!this.view) {
      return;
    }
    createjs.Tween.removeTweens(this.view);
    this.view.set({ scaleX: 1, scaleY: 1 });
  }

  hide() {
    if (!this.view) {
      return;
    }
    createjs.Tween.removeTweens(this.view);
    this.view.visible = false;
  }
}



// WEBPACK FOOTER //
// ../base/js/display/Sbl.js